<template>
  <div>
    <div style="text-align:right;">
      <a-button
        v-if="show"
        style="width: 10%;  margin-bottom:10px;margin-right:10px;"
        type="primary"
        block
        @click="handleModal"
      >
        关联客户
      </a-button>
      <a-button
        style="width: 5%;margin-bottom:10px;"
        v-if="show"
        type="primary"
        block
        @click="showFalse"
      >
        返回
      </a-button>
    </div>
    <div style="text-align:right;" v-if="infoshow && !show">
      <a-button
        style="width: 5%;margin-bottom:10px;"
        slot="tabBarExtraContent"
        @click="goBack"
        type="primary"
      >
        返回
      </a-button>
    </div>
    <a-card :class="{ 'wx-customer-list': show }" :bordered="false">
      <!-- 查看区域 -->
      <div id="components-layout-demo-basic" v-if="show">
        <a-layout>
          <a-layout-sider>
            <div
              style="height: 98%;width:90%;background: white;margin: 8px auto;"
            >
              <a-avatar
                class="wx-customer-list-avatar"
                :size="64"
                icon="user"
                :src="getAvatarView(view.avatar)"
              />
              <ul style="margin-top: 18px;text-align: left">
                <li class="wx-customer-list-avatar-li">
                  <span>昵称:</span><b>{{ view.name }}</b>
                </li>
                <li class="wx-customer-list-avatar-li">
                  <span>性别:</span><b>{{ view.gender }}</b>
                </li>
                <li class="wx-customer-list-avatar-li">
                  <span>类型:</span><b>{{ view.type }}</b>
                </li>
                <li class="wx-customer-list-avatar-li" @click="openD">
                  <span>企业微信:</span>
                  <!-- <a-icon type="form" /><br /> -->
                  <!-- <a-tag v-for="(item,index) in byCus.clientLabel" color="blue" :key="index">
                  标签一
                </a-tag> -->
                  <div v-if="byCus.tagInfo">
                    <a-tag
                      v-for="(item, index) in byCus.tagInfo.name"
                      color="blue"
                      :key="index"
                    >
                      {{ item }}
                    </a-tag>
                  </div>
                  <div v-else>
                    <b>暂无标签</b>
                  </div>
                </li>
                <li
                  class="wx-customer-list-avatar-li"
                  v-if="relateCustomer && relateCustomer.custFn"
                >
                  <div>
                    <span>关联客户：</span>
                    <span>{{ relateCustomer.custFn }}</span
                    ><br />
                    <span>客户号：</span>
                    <span>{{ relateCustomer.custId }}</span>
                  </div>
                </li>
              </ul>
              <!-- <a-icon type="edit" style="float: right;margin-top: -15px" @click="basicEdit"/>-->
              <!-- <a style="color: rgba(131, 125, 128, 0.93);">一 一 一 一 一 一 一 一 一 一</a>
            <ul style="margin-top: 18px;text-align: left">
              <li class="wx-customer-list-avatar-li"><span>客戶等級:</span><b>{{view.grade}}</b></li>
              <li class="wx-customer-list-avatar-li"><span>风险偏好:</span><b>{{view.hobby}}</b></li>
              <li class="wx-customer-list-avatar-li"><span>持有产品:</span><b>{{view.label}}</b></li>
            </ul> -->
              <!-- <a-icon type="edit" style="float: right;margin-top: -15px" @click="basicEdit"/> -->
            </div>
          </a-layout-sider>
          <a-layout>
            <a-layout-header>
              <a-row type="flex" style="height: 100%">
                <a-col :span="5">
                  <a-statistic
                    title="联系人总数"
                    :value="userNum"
                    style="width: 80%;margin-top: 28px; text-align: left"
                  >
                  </a-statistic>
                  <a class="verticalBar"></a>
                </a-col>
                <a-col :span="5">
                  <a-statistic
                    title="会话总数"
                    :value="conNum"
                    style="width: 80%;margin-top: 28px;text-align: left"
                  >
                  </a-statistic>
                  <a class="verticalBar"></a>
                </a-col>
                <a-col :span="5">
                  <a-statistic
                    title="消息总数"
                    :value="msgNum"
                    style="width: 80%;margin-top: 28px; text-align: left"
                  >
                  </a-statistic>
                  <a class="verticalBar"></a>
                </a-col>
                <a-col :span="9" style="color:red">
                  <a-statistic
                    title="最近发送消息时间"
                    :value="lastMessageTime"
                    style="width: 80%;margin-top: 28px; text-align: left"
                  >
                  </a-statistic>
                  <a class="verticalBar"></a>
                </a-col>
              </a-row>
            </a-layout-header>
            <a-layout-content>
              <div style="width: 100%;height: 7%;">
                <a-row type="flex" style="height: 50px">
                  <a-col
                    style="height:20%;font-weight: bold;margin-left: 30px;width: 30%;text-align: left;padding-top: 19px"
                  >
                    联系人
                  </a-col>
                  <a-col
                    style="height:10%;width: 62%;text-align: right;padding-top: 11px"
                  >
                    <div style="height: 10%;">
                      <!-- <a-input-search placeholder="请输入联系人姓名" style="width: 300px"/> -->
                    </div>
                  </a-col>
                </a-row>
              </div>
              <!-- 联系人 -->
              <div style="height: 12%;width: 100%;">
                <div
                  style=" float:left;margin-left: 20px;display:inline-block; height: 100%;"
                  v-for="(item, index) in byCus.follow_user"
                  :key="index"
                  @click="changeTable(index)"
                >
                  <!-- @click="jumpChatDataList(byCus.follow_user[index]) -->
                  <a-avatar
                    style="width:42px; height:42px;"
                    :src="item.avatar"
                  ></a-avatar>
                  <div
                    style="margin-top: 8px"
                    :class="index == indexInfo ? 'activeIndex' : ''"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div style="width: 100%;">
                    <a-row type="flex">
                      <a-col
                        style="background:rgb(24 144 255);height:23px;margin-left: 50px;width: 6px;text-align: left;margin-top: 16px"
                      >
                      </a-col>
                      <a-col
                        style="height:100%;margin-left: 8px;text-align: left;padding-top: 19px"
                      >
                        客户信息
                      </a-col>
                      <a-col
                        style="background:rgb(24 144 255);height:25px;margin-left:415px;width: 6px;text-align: left;margin-top: 16px"
                      >
                      </a-col>
                      <a-col
                        style="height:100%;margin-left: 8px;text-align: left;padding-top: 19px"
                      >
                        会话
                      </a-col>
                    </a-row>
                  </div>
                  <div style="width: 100%;margin-top: 20px">
                    <a-descriptions
                      :column="2"
                      style="width: 95%;margin: 0 auto;text-align: left;margin-left: 80px;margin-top: 23px"
                    >
                      <a-descriptions-item label="添加时间">
                        <a style="text-align: right"></a>
                        {{ byCus ? byCus.follow_user[indexInfo].time : '' }}
                      </a-descriptions-item>
                      <a-descriptions-item
                        label="消息数"
                        style="margin-left: 20px;"
                      >
                        <div
                          style="display: flex; align-items: center;justify-content: row;"
                        >
                          <div>
                            {{
                              byCus
                                ? byCus.follow_user[indexInfo].messageNumber
                                : ''
                            }}
                          </div>
                          <div
                            style="color: #548FFB;cursor: pointer;"
                            @click="
                              jumpChatDataList(byCus.follow_user[indexInfo])
                            "
                          >
                            &nbsp;&nbsp;查看会话
                          </div>
                        </div>
                      </a-descriptions-item>
                      <a-descriptions-item label="添加方式">
                        {{ addWay }}
                      </a-descriptions-item>
                      <a-descriptions-item label="客户最近发送消息时间">
                        {{
                          byCus ? byCus.follow_user[indexInfo].messageTime : ''
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item
                        label="联系人最近发送消息时间"
                        :span="2"
                      >
                        {{
                          byCus
                            ? byCus.follow_user[indexInfo]
                                .externalLastSendMessageTime
                            : ''
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item label="备注">
                        {{ byCus ? byCus.follow_user[indexInfo].remark : '' }}
                      </a-descriptions-item>
                      <a-descriptions-item> </a-descriptions-item>
                      <a-descriptions-item label="企业名称">
                        {{ byCus ? byCus.external_contact.corp_full_name : '' }}
                      </a-descriptions-item>
                      <a-descriptions-item> </a-descriptions-item>
                      <a-descriptions-item label="手机号码">
                        {{
                          byCus
                            ? byCus.follow_user[indexInfo].remark_mobiles[0]
                            : ''
                        }}
                      </a-descriptions-item>

                      <a-descriptions-item> </a-descriptions-item>
                      <a-descriptions-item label="描述">
                        {{
                          byCus ? byCus.follow_user[indexInfo].description : ''
                        }}
                      </a-descriptions-item>
                      <a-descriptions-item> </a-descriptions-item>
                      <a-descriptions-item label="个人标签">
                        <div
                          v-if="
                            byCus &&
                              byCus.follow_user[indexInfo].tags.length > 0
                          "
                        >
                          <a-tag
                            v-for="(item, index) in byCus.follow_user[indexInfo]
                              .tags"
                            color="blue"
                            :key="index"
                          >
                            {{ item.tag_name }}
                          </a-tag>
                        </div>
                        <div v-else>
                          暂无标签
                        </div>
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </div>
              </div>
            </a-layout-content>
          </a-layout>
          <a-drawer
            title="选择标签"
            placement="right"
            :closable="false"
            :visible="showdrawer"
            @close="noShowDrawer"
          >
            <a-tree
              checkable
              :tree-data="treeData"
              :default-expanded-keys="['0-0-0', '0-0-1']"
              :default-selected-keys="['0-0-0', '0-0-1']"
              :default-checked-keys="['0-0-0', '0-0-1']"
              :replace-fields="replaceFields"
              @select="onSelect"
              @check="onCheck"
            />
          </a-drawer>
        </a-layout>
      </div>
      <div style="margin-bottom:40px;" v-if="infoshow && !show">
        <a-tabs default-active-key="1" :size="Small">
          <a-tab-pane key="1" tab="客户信息">
            <div class="infoCustomer">
              <div class="userinfo">
                <h1>基本信息</h1>
                <a-button class="button" @click="basicEdit()">
                  编辑
                </a-button>
                <a-avatar
                  :size="64"
                  icon="user"
                  style="position:absolute;top:44px;"
                  :src="getAvatarView(view.avatar)"
                />
                <ul>
                  <li>
                    <span class="label">客户名称:</span><b>{{ view.name }}</b>
                  </li>
                  <li>
                    <span class="label">性别:</span><b>{{ view.gender }}</b>
                  </li>
                  <li>
                    <span class="label">类型:</span><b>{{ view.type }}</b>
                  </li>
                  <li>
                    <span class="label">手机号码:</span><b>{{ view.phone }}</b>
                  </li>
                  <li>
                    <span class="label">企业名称:</span
                    ><b>{{ view.corp_name }}</b>
                  </li>
                </ul>
              </div>
              <a-divider />
              <div class="taginfo">
                <h1>客户标签</h1>
                <a-button class="button" @click="labelEdit">
                  编辑
                </a-button>
                <ul>
                  <li>
                    <span class="label">客户等级:</span>
                    <a-tag
                      color="blue"
                      v-for="item in view.grade"
                      :key="item"
                      v-if="view.grade == null ? false : true"
                    >
                      {{ item }}
                    </a-tag>
                    <a-tag v-if="view.grade.length == 0">
                      -
                    </a-tag>
                  </li>
                  <li>
                    <span class="label">兴趣爱好:</span>
                    <a-tag
                      color="blue"
                      v-for="item in view.hobby"
                      :key="item"
                      v-if="view.hobby == null ? false : true"
                    >
                      {{ item }}
                    </a-tag>
                    <a-tag v-if="view.hobby.length == 0">
                      -
                    </a-tag>
                  </li>
                  <li>
                    <span class="label">自定义标签:</span>
                    <a-tag
                      color="blue"
                      v-for="item in view.other"
                      :key="item"
                      v-if="view.other == null ? false : true"
                    >
                      {{ item }}
                    </a-tag>
                    <a-tag v-if="view.other.length == 0">
                      -
                    </a-tag>
                  </li>
                </ul>
              </div>
              <a-divider />
              <basic-modal
                ref="basicModal"
                @searchReset="searchReset"
              ></basic-modal>
              <label-modal
                ref="labelModal"
                @searchReset="searchReset"
              ></label-modal>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="会话信息">
            <div class="userinfo">
              <h1>基本信息</h1>
              <ul>
                <li><span class="label">会话记录数:</span><b>12</b></li>
                <li><span class="label">参与群聊:</span><b>8</b></li>
                <li>
                  <span class="label">最近一次单独会话情况:</span
                  ><b>陈志强 2020.9.8 17:06:03</b>
                </li>
              </ul>
            </div>
            <a-divider />
            <!-- 跟当前客户联系过的销售 -->
            <div class="selllist">
              <h1>联系人</h1>
              <a-table :columns="columnsuser" :data-source="datatest">
                <a slot="name" slot-scope="text">{{ text }}</a>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="客户问题">
            <div style="width:100%;height:700px;">
              <iframe
                id="test"
                src="/share/4300000172966809/2FwkIdimbKkE7EkHI0H5v4b12i382382u7DWbbK2/4100000002452792/list"
                onload="setInterval(function(){
              var doc = document.getElementById('test').contentWindow.document;
              var strong = doc.getElementsByTagName('strong')[0];
              if(strong){strong.innerHTML='佳锐科技';};
              var list = doc.getElementsByTagName('a');
              for(var e in list)
              if(list[e].innerHTML=='伙伴云'){list[e].innerHTML='佳锐科技';list[e].href='http://www.aresoft.cn'}
              },100)"
                frameborder="0"
                width="100%"
                height="800px"
                scrolling="auto"
              ></iframe>
            </div>
          </a-tab-pane>
          <!-- <a-button slot="tabBarExtraContent" @click="goBack" type="primary">
          返回
        </a-button> -->
        </a-tabs>
      </div>
      <!-- 查询区域 -->
      <div v-if="!infoshow && !show">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="12">
                <a-form-item label="名称">
                  <a-input
                    placeholder="输入名称查询"
                    v-model="queryParam.name"
                  ></a-input>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item label="性别">
                  <a-select
                    v-model="queryParam.gender"
                    placeholder="请选择性别"
                  >
                    <a-select-option value="">请选择</a-select-option>
                    <a-select-option value="1">男性</a-select-option>
                    <a-select-option value="2">女性</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <!-- 标签 -->
              <!-- TODO -->
              <a-form-item
                v-if="false"
                label="标签 "
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                v-show="!departDisabled"
              >
                <a-input-search
                  placeholder="点击选择标签"
                  v-model="queryParam.tag"
                  readOnly
                  @search="viewLabel('5')"
                >
                  <a-button slot="enterButton" icon="search">选择</a-button>
                </a-input-search>
              </a-form-item>

              <a-col :md="6" :sm="8">
                <span
                  style="float: left;overflow: hidden;"
                  class="table-page-search-submitButtons"
                >
                  <a-button type="primary" @click="searchQuery" icon="search"
                    >查询</a-button
                  >
                  <a-button
                    type="primary"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px"
                    >重置</a-button
                  >
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 操作按钮区域 -->
        <div class="table-operator" style="border-top: 5px">
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item key="1">
                <a-icon type="plus" />
                批量加标签
              </a-menu-item>
              <a-menu-item key="2">
                <a-icon type="minus" />
                批量移除标签
              </a-menu-item>
              <a-menu-item key="3">
                <a-popconfirm
                  title="确定要进行清空吗？"
                  ok-text="Yes"
                  cancel-text="No"
                  @confirm="confirm"
                  @cancel="cancel"
                >
                  <a-icon href="#" type="close" />
                  批量清空标签
                </a-popconfirm>
              </a-menu-item>
              <!--            <a-menu-item key="4">-->
              <!--              <a-icon type="delete"/>-->
              <!--              批量删除-->
              <!--            </a-menu-item>-->
            </a-menu>
            <a-button style="margin-left: 8px">
              批量操作
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
          <customer-window
            ref="customerWindow"
            @searchReset="searchReset"
            @ok="modalFormOk"
          ></customer-window>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i
            >已选择&nbsp;<a style="font-weight: 600">{{
              selectedRowKeys.length
            }}</a
            >项&nbsp;&nbsp;
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>

          <a-table
            ref="table"
            bordered
            size="middle"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
            :rowKey="r => r.external_contact.external_userid"
            @change="handleTableChange"
          >
            <template slot="avatarslot" slot-scope="text, record">
              <a-avatar
                shape="square"
                :src="getAvatarView(record.external_contact.avatar)"
                icon="user"
              />
            </template>
            <template slot="tag" slot-scope="text, record">
              <a v-if="!record.tagInfo">
                --
              </a>
              <a-tag
                color="#108ee9"
                v-for="item in record.tagInfo.name"
                :key="item"
                v-else
              >
                {{ item }}
              </a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <a @click="userInfo(record)">查看</a>
            </template>
          </a-table>
        </div>
      </div>
      <!-- table区域-end -->

      <!-- <chat-modal ref="modalForm" @ok="modalFormOk"></chat-modal> -->
    </a-card>
    <a-modal v-model="showModal" width="800px" title="关联客户" @ok="handleOk">
      <div class="searchtop">
        <a-input-search
          placeholder="请输入手机号"
          enter-button="搜索"
          v-model="searchInfo"
          @search="onSearch"
        />
      </div>
      <a-table
        :columns="columnsCustomer"
        :data-source="customerData"
        :row-selection="{
          type: 'radio',
          selectedRowKeys: selectedRowKeys,
          onChange: customerSelect
        }"
        :loading="crmloading"
      >
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getFileAccessHttpUrl } from '@/api/manage';
import {
  frozenBatch,
  emptyLabel,
  getContactByCus,
  getCrmCustomerInfo,
  bindCrmCustomer,
  queryCrmCustomerDetail
} from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JInput from '@/components/jeecg/JInput';
import UserRecycleBinModal from '../../system/modules/UserRecycleBinModal';
import ChatModal from './ChatModal';
import moment from 'moment';
import customerWindow from './TagWindow';
import basicModal from './BasicModal';
import labelModal from './LabelModal';

export default {
  name: 'wxCustomerList',
  mixins: [JeecgListMixin],
  components: {
    JInput,
    UserRecycleBinModal,
    ChatModal,
    customerWindow,
    basicModal,
    labelModal
  },
  data: function() {
    return {
      msgNum: 0,
      conNum: 0,
      lastMessageTime: '暂无',
      userNum: 0,
      indexInfo: 0,
      showTable: false,
      byCus: '',
      description: '这是企业微信销售管理页面',
      queryParam: {
        userId: this.$route.query.userId,
        tag: ''
      },
      addWay: '',
      show: false,
      external_userid: '',
      departDisabled: false, //是否是我的部门调用该页面
      selectedDepartKeys: [], //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [], // 保存部门的名称 =>title
      checkedDepartNameString: '', // 保存部门的名称 =>title
      departIds: [],
      records: [],
      resultDepartOptions: [],
      view: {
        other: '',
        avatar: '',
        name: '',
        gender: '',
        type: '',
        phone: '',
        corp_name: '',
        grade: '',
        hobby: '',
        label: ''
      },
      labels: [],
      recycleBinVisible: false,
      infoshow: false,
      datatest: [],
      columnsuser: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index'
        },
        {
          title: '联系人名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '添加时间',
          dataIndex: 'addtime',
          key: 'addtime',
          ellipsis: true
        },
        {
          title: '添加方式',
          dataIndex: 'addtype',
          key: 'addtype'
        },
        {
          title: '添加员',
          dataIndex: 'adduser',
          key: 'adduser'
        },
        {
          title: '渠道',
          dataIndex: 'qd',
          key: 'qd'
        },
        {
          title: '会话记录数',
          dataIndex: 'talk',
          key: 'talk',
          ellipsis: true
        },
        {
          title: '备注',
          dataIndex: 'bz',
          key: 'bz',
          ellipsis: true
        },
        {
          title: '描述',
          dataIndex: 'ms',
          key: 'ms',
          ellipsis: true
        }
      ],
      columns: [
        {
          title: '客户名称',
          align: 'center',
          width: 100,
          dataIndex: 'external_contact.name'
        },
        {
          title: '客户头像',
          align: 'center',
          width: 100,
          dataIndex: 'external_contact.avatar',
          scopedSlots: { customRender: 'avatarslot' }
        },
        {
          title: '标签',
          dataIndex: 'tag',
          scopedSlots: { customRender: 'tag' },
          align: 'center',
          ellipsis: true,
          width: 170
          // customCell: () => {
          //   return {
          //     style: {
          //       'max-width': '100px',
          //     },
          //   };
          // },
        },
        {
          title: '客户类型',
          align: 'center',
          width: 120,
          dataIndex: 'external_contact.type',
          customRender: function(text, record, index) {
            if (text === 1) {
              return '微信用户';
            } else if (text === 2) {
              return '企业微信用户';
            } else {
              return '未知';
            }
          }
        },
        {
          title: '性别',
          align: 'center',
          width: 80,
          dataIndex: 'external_contact.gender',
          customRender: function(text, record, index) {
            if (text === 1) {
              return '男性';
            } else if (text === 2) {
              return '女性';
            } else {
              return '无';
            }
          }
        },
        // {
        //   title: '联系人数',
        //   align: 'center',
        //   width: 80,
        //   dataIndex: 'userNum',
        //   scopedSlots: { customRender: 'userNum' }
        // },
        {
          title: '客户群数',
          align: 'center',
          width: 80,
          dataIndex: 'wechatGroupNum'
        },
        {
          title: '最新消息时间',
          align: 'center',
          width: 180,
          dataIndex: 'lastMessageTime',
          customRender: function(text, record, index) {
            if (text == null) {
              return '-';
            } else {
              return text;
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 100
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER + '/wechatwork/client/data',
        deleteBatch:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/market/userDeleteBatch'
      },
      showdrawer: false,
      treeData: [
        {
          name: 'parent 1',
          key: '0-0',
          child: [
            {
              name: '张晨成',
              key: '0-0-0',
              disabled: true,
              child: [
                { name: 'leaf', key: '0-0-0-0', disableCheckbox: true },
                { name: 'leaf', key: '0-0-0-1' }
              ]
            },
            {
              name: 'parent 1-1',
              key: '0-0-1',
              child: [{ key: '0-0-1-0', name: 'zcvc' }]
            },
            {
              name: '1',
              key: '0-1-1',
              child: [{ key: '0-1-0-0', name: '你我他他他' }]
            },
            {
              name: 'parent 1-1',
              key: '0-1-0',
              child: [{ key: '1-0-1-0', name: '我你她她她' }]
            }
          ]
        }
      ],
      replaceFields: {
        children: 'child',
        title: 'name'
      },
      showModal: false, //模态框
      columnsCustomer: [
        {
          title: '客户名称',
          dataIndex: 'custFn'
        },
        {
          title: '客户号',
          dataIndex: 'custId'
        },
        {
          title: '手机号',
          dataIndex: 'phone'
        },
        {
          title: '证件号',
          dataIndex: 'certCode'
        },
        {
          title: '证件类型',
          dataIndex: 'certTypeName'
        }
      ],
      customerData: [],
      selectedRowKeys: [],
      selectedRows: [],
      relateCustomer: {},
      searchInfo: '',
      crmloading: false,
      externalId: '' //外部联系人id
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  // inject: ['reload'],
  methods: {
    changeTable(index) {
      this.indexInfo = index;
    },
    confirm(e) {
      let formData = {
        user: this.selectedRowKeys
      };
      emptyLabel(formData).then(res => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.success(res.message);
        }
        this.searchReset();
        // this.reload()
        this.close();
      });
    },
    cancel(e) {
      this.$message.error('Click on No');
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    handleMenuClick(e) {
      this.viewLabel(e.key);
    },
    basicEdit() {
      let data = this.view;
      let records = this.records;
      this.$refs.basicModal.add(data, records);
    },
    userInfo(record) {
      this.show = true;
      let formData = new FormData();
      formData.userId = record.external_contact.external_userid;
      this.externalId = formData.userId;

      getContactByCus(formData).then(res => {
        this.byCus = res;
        if (this.byCus.follow_user[0].add_way == 0) {
          this.addWay = '未知来源';
        } else if (this.byCus.follow_user[0].add_way == 1) {
          this.addWay = '扫描二维码';
        } else if (this.byCus.follow_user[0].add_way == 2) {
          this.addWay = '搜索手机号';
        } else if (this.byCus.follow_user[0].add_way == 3) {
          this.addWay = '名片分享';
        } else if (this.byCus.follow_user[0].add_way == 4) {
          this.addWay = '群聊';
        } else if (this.byCus.follow_user[0].add_way == 5) {
          this.addWay = '手机通讯录';
        } else if (this.byCus.follow_user[0].add_way == 6) {
          this.addWay = '微信联系人';
        } else if (this.byCus.follow_user[0].add_way == 7) {
          this.addWay = '来自微信添加的好友';
        } else if (this.byCus.follow_user[0].add_way == 8) {
          this.addWay = '安装第三方应用自动添加的客服';
        } else if (this.byCus.follow_user[0].add_way == 9) {
          this.addWay = '搜索邮箱';
        } else if (this.byCus.follow_user[0].add_way == 201) {
          this.addWay = '内部成员共享';
        } else if (this.byCus.follow_user[0].add_way == 202) {
          this.addWay = '管理员分配';
        } else {
          this.addWay = '';
        }
        if (res.conNum != null) {
          this.conNum = this.byCus.conNum;
        }
        if (res.msgNum != null) {
          this.msgNum = this.byCus.msgNum;
        }
        if (res.lastMessageTime != null) {
          this.lastMessageTime = this.byCus.lastMessageTime;
        }
        if (res.userNum != null) {
          this.userNum = this.byCus.userNum;
        }
        this.getCrmCustomerDetail(res.customerId);
      });
      this.view.name = record.external_contact.name;

      if (record.external_contact.type === 1) {
        this.view.type = '微信用户';
      } else {
        this.view.type = '企业用户';
      }
      if (record.external_contact.gender === 1) {
        this.view.gender = '男性';
      } else if (record.external_contact.gender === 2) {
        this.view.gender = '女性';
      } else {
        this.view.gender = '未知';
      }
      this.view.avatar = record.external_contact.avatar;
      this.view.corp_name = record.external_contact.corp_name;
      if (
        record.follow_info.remark_mobiles != null &&
        record.follow_info.remark_mobiles.length > 0
      ) {
        for (var e in record.follow_info.remark_mobiles) {
          this.view.phone = record.follow_info.remark_mobiles[e] + '';
        }
      }
      if (record.grade != null) {
        this.view.grade = record.grade.join(',');
      }
      if (record.hobby != null) {
        this.view.hobby = record.hobby.join(',');
      }
      if (record.other != null) {
        this.view.other = record.other.join(',');
      }
      if (record.label != null) {
        this.view.label = record.label.join(',');
      }
    },
    labelEdit() {
      let data = this.view;
      let records = this.records;
      this.$refs.labelModal.add(data, records);
    },
    viewLabel(key) {
      this.$refs.customerWindow.add(key, this.selectedRowKeys);
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.departList = [];
      this.checkedKeys = [];
    },
    jumpinfo(record) {
      let formData = new FormData();
      formData.userId = record.external_contact.external_userid;
      getContactByCus(formData).then(res => {
        if (res.success) {
          this.roleList = res.result;
        } else {
          console.log(res.message);
        }
      });

      this.records = record;
      this.view.name = record.external_contact.name;
      if (record.external_contact.type === 1) {
        this.view.type = '微信用户';
      } else {
        this.view.type = '企业用户';
      }
      if (record.external_contact.gender === 1) {
        this.view.gender = '男性';
      } else if (record.external_contact.gender === 2) {
        this.view.gender = '女性';
      } else {
        this.view.gender = '未知';
      }
      this.view.avatar = record.external_contact.avatar;
      this.view.corp_name = record.external_contact.corp_name;
      if (
        record.follow_info.remark_mobiles != null &&
        record.follow_info.remark_mobiles.length > 0
      ) {
        for (var e in record.follow_info.remark_mobiles) {
          this.view.phone = record.follow_info.remark_mobiles[e] + '';
        }
      }
      if (record.grade != null) {
        this.view.grade = record.grade;
      }
      if (record.hobby != null) {
        this.view.hobby = record.hobby;
      }
      if (record.other != null) {
        this.view.other = record.other;
      }
      this.infoshow = true;
    },
    showFalse() {
      this.show = false;
    },
    goBack() {
      this.infoshow = false;
    },
    // 跳转单人详细聊天界面
    JumpChatInfo(record) {
      console.log('qweqweqweqa ');
      this.$router.push({
        ///wechatwork/customer/CustomerInfo
        path: '/CustomerInfo',
        query: { id: record.externalUserId, type: 1 }
      });
    },

    ///跳转信息查看页面
    jumpChatDataList(record) {
      this.$router.push({
        // path: '/wechatwork/supervision/chatDataList',
        path: '/wechatwork/supervision/chatDataListRe',
        query: {
          condition: record.name,
          type: 2,
          sendId: record.userid,
          externalId: this.externalId,
          chatTypeFlg: '1'
        }
      });
    },
    // 获取用户对应部门弹出框提交给返回的数据
    modalFormOk(formData) {
      this.checkedDepartNames = [];
      this.selectedDepartKeys = [];
      this.checkedDepartNameString = '';
      this.departIds = [];
      this.resultDepartOptions = [];
      this.queryParam.tag = [];
      var depart = [];
      for (var i = 0; i < formData.departIdList.length; i++) {
        this.selectedDepartKeys.push(formData.departIdList[i].key);
        this.checkedDepartNames.push(formData.departIdList[i].title);
        this.queryParam.tag = this.checkedDepartNames.join(',');
        //新增部门选择，如果上面部门选择后不为空直接付给负责部门
        depart.push({
          key: formData.departIdList[i].key,
          title: formData.departIdList[i].title
        });
        this.departIds.push(formData.departIdList[i].key);
      }
      //     }
      //   }
      // });
      this.resultDepartOptions = depart;
      this.userDepartModel.departIdList = this.selectedDepartKeys;
      this.checkedDepartKeys = this.selectedDepartKeys; //更新当前的选择keys
      this.searchReset();
      // this.reload()
    },
    noShowDrawer() {
      this.showdrawer = false;
    },
    onSelect(selectedKeys, info) {
      console.log('selected', selectedKeys, info);
    },
    onCheck(checkedKeys, info) {
      console.log('onCheck', checkedKeys, info);
    },
    openD() {
      // this.showdrawer=true;
      // console.log("-=-=-=-=-=-=-",this.showdrawer);
    },
    handleModal() {
      this.showModal = true;
    },
    handleOk() {
      this.showModal = false;
      let obj = {};
      if (this.selectedRows && this.selectedRows.length > 0) {
        obj = this.selectedRows[0];
      }

      let param = {
        weChatContactId: this.externalId,
        custId: obj.custId,
        custType: obj.custType,
        phone: obj.phone
      };
      bindCrmCustomer(param).then(res => {
        if (res.success) {
          this.relateCustomer = obj;
        }
      });
    },
    customerSelect(selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onSearch() {
      if (this.searchInfo == '') {
        return;
      }
      this.crmloading = true;
      getCrmCustomerInfo({ phone: this.searchInfo }).then(res => {
        this.crmloading = false;
        if (res.success && res.result && res.result.records) {
          this.customerData =
            res.result.records.length > 0 ? res.result.records : [];
        } else {
          this.customerData = [];
        }
      });
    },
    getCrmCustomerDetail(id) {
      queryCrmCustomerDetail({ custId: id }).then(res => {
        console.log('res*******', res);
        if (res.code == 0 && res.result) {
          this.relateCustomer = res.result;
        }
      });
    }
  }
};
</script>
<style scoped>
/deep/ .ant-layout-sider {
  flex: 0 0 210px !important;
  max-width: 210px !important ;
}
</style>
<style lang="less">
.userinfo,
.taginfo {
  position: relative;

  .button {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.userinfo ul,
.taginfo ul {
  list-style: none;
  margin: 20px 0 0 20px;
}

.userinfo ul li,
.taginfo ul li {
  margin-top: 10px;
}

.userinfo ul li .label,
.taginfo ul li .label {
  display: inline-block;
  width: 160px;
  text-align: right;
}

.taginfo ul li .label {
  margin-right: 20px;
}

.userinfo ul li b {
  margin-left: 10px;
}

#components-layout-demo-basic {
  text-align: center;
  margin-top: 0;
}

#components-layout-demo-basic .ant-layout-header {
  height: 13%;
  margin-left: 10px;
  font-weight: 800;
  background: white;
  color: rgba(131, 125, 128, 0.93);
}

#components-layout-demo-basic .ant-layout-footer {
  background: red;
}

#components-layout-demo-basic .ant-layout-footer {
  line-height: 1.5;
}

#components-layout-demo-basic .ant-layout-sider {
  background: white;
  line-height: 37px;
}

#components-layout-demo-basic .ant-layout-content {
  margin-left: 10px;
  margin-top: 10px;
  background: white;
  height: 800px;
  color: black;
}

#components-layout-demo-basic > .ant-layout {
  margin-bottom: 34px;
}

#components-layout-demo-basic > .ant-layout:last-child {
  margin: 0;
}
</style>

<style>
.wx-customer-list-avatar-li {
  list-style-type: none;
}

.wx-customer-list-avatar {
  margin-top: 20px;
}

.wx-customer-list > .ant-card-body {
  padding: 0;
}

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: white;
}

.editable-add-btn {
  margin-bottom: 8px;
}

.verticalBar {
  float: right;
  width: 1px;
  height: 80px;
  background: rgba(210, 204, 207, 0.93);
  display: inline-block;
  margin-top: -68px;
  vertical-align: top;
  margin-right: 30px;
}
</style>
<style scoped>
@import '~@assets/less/common.less';
.activeIndex::after {
  content: '';
  background: #1890ff;
  width: 20px;
  height: 2px;
  margin-top: 12px;
  margin-left: 11px;
  display: block;
}
.searchtop {
  width: 100%;
  margin-bottom: 10px;
}
.searchtop /deep/.ant-input-group {
  width: 50%;
}
</style>
